import { render } from "./InvoicingItemsTable.vue?vue&type=template&id=36a33e25"
import script from "./InvoicingItemsTable.vue?vue&type=script&lang=js"
export * from "./InvoicingItemsTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__